import { Modal } from "@components/index";
import { formatCurrency, formatDate } from "@utils/index";
import "./index.scss";

const ClaimDetailsModal = ({ isOpen, onClose, claim, onActionClick }) => {
  if (!claim) return null;

  const handleActionClick = (action) => {
    if (onActionClick) {
      onActionClick(claim, action);
    }
  };

  const detailSections = [
    {
      title: "Claim Information",
      fields: [
        { label: "Claim ID", value: claim.claim_id },
        { label: "Policy Reference No", value: claim.policy_reference_no },
        { label: "Partner ID", value: claim.partner_id },
        { label: "Audit Reference No", value: claim.audit_reference_no },
        // { label: 'Claim Source', value: claim.claim_source },
      ],
    },
    {
      title: "Financial Details",
      fields: [
        { label: "Fare Amount", value: formatCurrency(claim.fare_amount) },
        ...(claim.refund_amount
          ? [
              {
                label: "Refund Amount",
                value: formatCurrency(claim.refund_amount),
              },
            ]
          : []),
        ...(claim.voucher_value
          ? [
              {
                label: "Voucher Value",
                value: formatCurrency(claim.voucher_value),
              },
            ]
          : []),
        ...(claim.refund_mode
          ? [{ label: "Refund Mode", value: claim.refund_mode }]
          : []),
      ],
    },
    {
      title: "Customer & Journey Details",
      fields: [
        { label: "PNR Number", value: claim.pnr_number },
        { label: "Customer Email", value: claim.customer_email },
        { label: "Customer Mobile", value: claim.customer_mobile },
        { label: "Journey Date", value: formatDate(claim.journey_date) },
        { label: "Number of Passengers", value: claim.no_of_passengers },
      ],
    },
    {
      title: "Status Information",
      fields: [
        { label: "Claim Status", value: claim.claim_status },
        ...(claim.rejection_reason
          ? [{ label: "Rejection Reason", value: claim.rejection_reason }]
          : []),
        { label: "Chart Status", value: claim.chart_status },
        { label: "Final Ticket Status", value: claim.final_ticket_status },
        {
          label: "Train Cancellation Status",
          value: claim.train_cancellation_status,
        },
        ...(claim.settlement_channel
          ? [{ label: "Settlement Channel", value: claim.settlement_channel }]
          : []),
        {
          label: "Partner Wallet Flag",
          value: claim.partner_wallet_flag ? "Yes" : "No",
        },
      ],
    },
    {
      title: "Transaction Details",
      fields: [
        ...(claim.voucher_code
          ? [{ label: "Voucher Code", value: claim.voucher_code }]
          : []),
        ...(claim.voucher_validity
          ? [
              {
                label: "Voucher Validity",
                value: formatDate(claim.voucher_validity),
              },
            ]
          : []),
        ...(claim.refund_txn_id
          ? [{ label: "Refund Transaction ID", value: claim.refund_txn_id }]
          : []),
        ...(claim.voucher_txn_id
          ? [
              {
                label: "Voucher Transaction ID",
                value: claim.voucher_txn_id,
              },
            ]
          : []),
      ],
    },
    {
      title: "Timeline & Remarks",
      fields: [
        {
          label: "Claim Initiation",
          value: formatDate(claim.claim_initiation_datetime),
        },
        {
          label: "Settlement Date",
          value: claim.settlement_datetime
            ? formatDate(claim.settlement_datetime)
            : "Settlement Pending",
        },
        ...(claim.remarks ? [{ label: "Remarks", value: claim.remarks }] : []),
      ],
    },
  ];

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        className="claim-details-modal"
        showCloseIcon={false}
      >
        <div className="claim-details-modal__header">
          <h2 className="claim-details-modal__title">
            Claim Details - {claim.claim_id}
          </h2>
          <button
            className="claim-details-modal__close"
            onClick={onClose}
            aria-label="Close modal"
          >
            ×
          </button>
        </div>

        <div className="claim-details-modal__content">
          {detailSections.map(
            (section, index) =>
              section.fields.length > 0 && (
                <div key={index} className="claim-details-modal__section">
                  <h3 className="claim-details-modal__section-title">
                    {section.title}
                  </h3>
                  <div className="claim-details-modal__fields">
                    {section.fields.map((field, fieldIndex) => (
                      <div
                        key={fieldIndex}
                        className="claim-details-modal__field"
                      >
                        <span className="claim-details-modal__label">
                          {field.label}:
                        </span>
                        <span className="claim-details-modal__value">
                          {field.value}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              ),
          )}
        </div>

        {claim.claim_status === "Pending" && (
          <div className="claim-details-modal__footer">
            <button
              className="claim-details-modal__btn claim-details-modal__btn--approve"
              onClick={() => handleActionClick("approve")}
            >
              Approve
            </button>
            <button
              className="claim-details-modal__btn claim-details-modal__btn--reject"
              onClick={() => handleActionClick("reject")}
            >
              Reject
            </button>
          </div>
        )}
      </Modal>
    </>
  );
};

export default ClaimDetailsModal;
